"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertToDate_1 = require("./convertToDate");
var yoriMae_1 = require("./yoriMae");
var yoriAto_1 = require("./yoriAto");
var toOnaji_1 = require("./toOnaji");
var toOnajiKaMae_1 = require("./toOnajiKaMae");
var toOnajiKaAto_1 = require("./toOnajiKaAto");
var noAida_1 = require("./noAida");
function ha(date1, date2) {
    return {
        yoriMae: function () { return yoriMae_1.default(date1, date2); },
        yoriAto: function () { return yoriAto_1.default(date1, date2); },
        toOnaji: function () { return toOnaji_1.default(date1, date2); },
        toOnajiKaMae: function () { return toOnajiKaMae_1.default(date1, date2); },
        toOnajiKaAto: function () { return toOnajiKaAto_1.default(date1, date2); },
        to: function (date3) { return ({ noAida: function () { return noAida_1.default(date1, date2, convertToDate_1.default(date3)); } }); }
    };
}
exports.default = ha;
